export default __webpack_public_path__ + "static/img-finish-products-3e66127c4a75bc19d7e13c4ccbf88127.webp";